import React from 'react';

import PropTypes from 'prop-types';

import styles from './ErrorLabel.module.scss';

const ErrorLabel = ({ error }) => (
  <>{error && <span className={styles.error}>{error.message}</span>}</>
);

ErrorLabel.propTypes = {
  /** Error object */
  error: PropTypes.shape({
    message: PropTypes.string
  })
};

ErrorLabel.defaultProps = {
  error: null
};

export default ErrorLabel;
